import React, { use, useState } from 'react';
import { Button, Popconfirm, Space, Table, TableColumnsType, Tag } from 'antd';
import { useRequest } from 'ahooks';
import { useUpdate } from '@/common/hook';
import { ConversationListVo, getConversationList } from '@/api/chat';

const columns: TableColumnsType<ConversationListVo> = [
  { title: '回话名称 ', dataIndex: 'conversationName', key: 'conversationName' },
  { title: '所属流程', dataIndex: 'processDefinitionName', key: 'processDefinitionName' },
];

const ConversationList = () => {
  const [update, updateFn] = useUpdate();

  const { data: conversationList, loading } = useRequest(getConversationList, { refreshDeps: [update] });



  return (
    <>
      <Table<ConversationListVo> columns={columns} dataSource={conversationList ?? []} loading={loading} />
    </>
  );
};

export default ConversationList;
